import { render, staticRenderFns } from "./ShareTargetTransactionPopup.vue?vue&type=template&id=1e04062c&"
import script from "./ShareTargetTransactionPopup.vue?vue&type=script&lang=js&"
export * from "./ShareTargetTransactionPopup.vue?vue&type=script&lang=js&"
import style0 from "./ShareTargetTransactionPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports